import * as yup from 'yup';
import { isShipmentDomestic } from '../../containers/ServiceSelection/utils';

import { ShipmentType } from '../../types/common';
import { NAME_REGEX } from './item';

const shipSchema = yup
  .object()
  .shape({
    originCountry: yup.string().required(),
    destinationCountry: yup
      .string()
      .required('CountrySelect.destinationCountryRequired')
      .test(
        'is-not-the-same-as-origin-country',
        'CountrySelect.domesticShippingNotSupported',
        (value: string | undefined, context: any) =>
          !isShipmentDomestic(context.options.context.originCountry, value),
      ),
    documentItem: yup.string().when('$shipmentType', {
      is: (shipmentType: ShipmentType) => shipmentType === ShipmentType.DOCUMENT,
      then: yup
        .string()
        .trim()
        .matches(NAME_REGEX, 'Items.descriptionInvalidFormat')
        .required('Items.itemsRequired'),
      otherwise: yup.string(),
    }),
    parcelItems: yup.array().when('$shipmentType', {
      is: (shipmentType: ShipmentType) => shipmentType === ShipmentType.PARCEL,
      then: yup.array(yup.array().required('Items.itemsRequired').min(1, 'Items.itemsRequired')),
      otherwise: yup.array(),
    }),
    service: yup.string().required('ServiceSelection.serviceRequired'),
  })
  .defined();

export default shipSchema;
